import { css } from 'styled-components';
import { HeaderProps, HeaderRowCellProps, HeaderRowProps } from './models';
import { Divider, TableCell, TableRow } from '../../styles';

export const Header = css<HeaderProps>(({ theme }) => {
  return css`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fff;
    width: 100%;

    ${Divider};
  `;
});

export const HeaderRow = css<HeaderRowProps>(({ theme, }) => {

  return css`
    ${TableRow};
    background-color: #fff;
    align-items: end;


    > .empty-cell {
      ${TableCell};
      background-color: #fff;
      max-width: 20px;
      min-width: 20px;
      width: 20px;
    }
  `;
});

export const HeaderRowCell = css<HeaderRowCellProps>(({ theme, cellAmount, cellIndex, }) => {

  const backgroundColor = cellIndex % 2 === 0 ? '#fff' : '#FAFBFC';

  return css`
    ${TableCell}
    font-weight: 600;
    line-height: 21px;
    width: calc(100% / ${cellAmount});
    max-width: calc(100% / ${cellAmount});
    min-width: 150px;
    text-align: ${cellIndex ? 'center' : 'start'};
    background-color: ${backgroundColor};
    height: 100%;

    &:first-child {
      justify-content: start;
    }

    > .sort-container {
      width: 12px;
      margin-left: 5px;
      position: absolute;
      text-align: center;

      > .sort-button {
        width: 9.17px;
        height: 6px;
        border-radius: 50px;
        flex: none;
        margin-right: 28px;
        order: 0;
        align-self: center;
        flex-grow: 0;

        color: #8090b4;
      }
    }
  `;
});
